var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Email Opt-in ")]),
      _c(
        "gg-card-text",
        [
          _c("p", [
            _vm._v(
              " GreenGeeks sends emails to you occasionally, manage what emails you would like to receive. "
            )
          ]),
          _c("v-switch", {
            attrs: {
              label: "Onboarding & Feedback",
              loading: _vm.loading.onboarding,
              "input-value": _vm.SessionProfile.email_onboarding,
              "hide-details": ""
            },
            on: {
              change: function change($event) {
                return _vm.changeStatus(
                  "onboarding",
                  _vm.SessionProfile.email_onboarding
                )
              }
            }
          }),
          _c("v-switch", {
            attrs: {
              label: "New Features & Company Related News",
              loading: _vm.loading.news,
              "input-value": _vm.SessionProfile.email_news,
              "hide-details": ""
            },
            on: {
              change: function change($event) {
                return _vm.changeStatus("news", _vm.SessionProfile.email_news)
              }
            }
          }),
          _c("v-switch", {
            attrs: {
              label: "Promotional & Special Offers",
              loading: _vm.loading.promotions,
              "input-value": _vm.SessionProfile.email_promotions,
              "hide-details": ""
            },
            on: {
              change: function change($event) {
                return _vm.changeStatus(
                  "promotions",
                  _vm.SessionProfile.email_promotions
                )
              }
            }
          }),
          _c("v-switch", {
            attrs: {
              label: "Login Alerts",
              loading: _vm.loading.loginalerts,
              "input-value": _vm.SessionProfile.email_loginalerts,
              "hide-details": ""
            },
            on: {
              change: function change($event) {
                return _vm.changeStatus(
                  "loginalerts",
                  _vm.SessionProfile.email_loginalerts
                )
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }